import { render, staticRenderFns } from "./MultiselectDropdown.vue?vue&type=template&id=85d277e2&"
import script from "./MultiselectDropdown.vue?vue&type=script&lang=js&"
export * from "./MultiselectDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports